import React from 'react';
import PlanContent from './index';
import FreQuestion from '../Home/freQuestions/index';
import styles from './PlanPage.module.less';

interface PlanPageProps {
  data: any;
}

const PlanPage: React.FC<PlanPageProps> = ({ data }) => {
  return (
    <div>
      <PlanContent data={data} />
      {data.data.contentInfo['section-faq']?.title && data.data.faqList?.content_list?.length > 0 && (
        <div className={styles.faqContainer}>
          <FreQuestion data={data.data} />
        </div>
      )}
    </div>
  );
};

export default PlanPage;
